import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import PrimaryBtn from "src/Components/GlobalComponents/primaryBtn";
import SelectDropdown from "src/Components/GlobalComponents/SelectDropdown";
import CustomWebsiteDropdown from "src/Components/GlobalComponents/Widget/CustomWebsiteDropdown";
import httpRequest from "src/helpers/httpRequest";
import {
  IMainCategory,
  IPharmaInventoryCreate,
  ISubCategory,
} from "src/types/GlobalInterfaces";
import { Option } from "react-multi-select-component";

interface IProps {
  state: IPharmaInventoryCreate;
  setState: (key: keyof IPharmaInventoryCreate, val: string) => void;
  tabChange: () => void;
}

const InventoryCategoriesTab: React.FC<IProps> = ({
  state,
  setState,
  tabChange,
}) => {
  const [mainLoader, setMainLoader] = useState<boolean>(false);
  const [subLoader, setSubLoader] = useState<boolean>(false);
  const [childLoader, setChildLoader] = useState<boolean>(false);
  const [allMainCategory, setAllMainCategory] = useState<
    { value: string; label: string }[]
  >([]);
  const [allSubCategory, setAllSubCategory] = useState<
    { value: string; label: string }[]
  >([]);
  const [allChildCategory, setAllChildCategory] = useState<
    { value: string; label: string }[]
  >([]);

  const fetchAllMainCategories = async () => {
    setMainLoader(true);
    const { res, err } = await httpRequest<{ documents: IMainCategory[] }>({
      path: "/main-category/getAllMainCategory",
    });
    if (res) {
      const arr =
        res?.documents?.map((v) => ({
          value: v?._id,
          label: v?.categoryName,
        })) || [];
      setAllMainCategory(arr);
    } else {
      toast(err, { type: "error" });
    }
    setMainLoader(false);
  };

  const fetchSubCategories = async () => {
    setSubLoader(true);
    const { res, err } = await httpRequest<
      { _id: string; subCategoryName: string }[]
    >({ path: `/sub-category/getSubMyMainId/${state?.mainCategoryId}` });
    if (res) {
      const arr =
        res?.map((v) => ({ value: v?._id, label: v?.subCategoryName })) || [];
      setAllSubCategory(arr);
    } else {
      toast(err, { type: "error" });
    }
    setSubLoader(false);
  };

  const fetchChildCategories = async () => {
    setChildLoader(true);
    const { res, err } = await httpRequest<
      { _id: string; childCategoryName: string }[]
    >({ path: `/child-category/getChildMySubId/${state?.subCategoryId}` });
    if (res) {
      const arr =
        res?.map((v) => ({ value: v?._id, label: v?.childCategoryName })) || [];
      setAllChildCategory(arr);
    } else {
      toast(err, { type: "error" });
    }
    setChildLoader(false);
  };

  useEffect(() => {
    if (state?.subCategoryId) {
      fetchChildCategories();
    }
  }, [state?.subCategoryId]);

  useEffect(() => {
    if (state?.mainCategoryId) {
      fetchSubCategories();
    }
  }, [state?.mainCategoryId]);

  useEffect(() => {
    fetchAllMainCategories();
  }, []);
  return (
    <>
      <div className="products-tabs-content">
        <CustomWebsiteDropdown
          options={allMainCategory}
          data={allMainCategory.filter(
            (v) => v?.value === state?.mainCategoryId
          )}
          setData={(e) => setState("mainCategoryId", e[0]?.value || "")}
          labelText="Categories"
          isRequired={true}
          dropdownMainId="main-category-dropdown"
          clearId="main-category-clear"
          optionId={(v: Option, index) => `main-category-option-${index + 1}`}
          loading={mainLoader}
        />
        <CustomWebsiteDropdown
          options={allSubCategory}
          data={allSubCategory.filter((v) => v?.value === state?.subCategoryId)}
          setData={(e) => setState("subCategoryId", e[0]?.value || "")}
          labelText="Sub Categories"
          isRequired={true}
          dropdownMainId="sub-category-dropdown"
          clearId="sub-category-clear"
          optionId={(v: Option, index) => `sub-category-option-${index + 1}`}
          loading={subLoader}
        />
        <CustomWebsiteDropdown
          options={allChildCategory}
          data={allChildCategory.filter(
            (v) => v?.value === state?.childCategoryId
          )}
          setData={(e) => setState("childCategoryId", e[0]?.value || "")}
          labelText="Child Categories"
          isRequired={true}
          dropdownMainId="child-category-dropdown"
          clearId="child-category-clear"
          optionId={(v: Option, index) => `child-category-option-${index + 1}`}
          loading={childLoader}
        />
      </div>
      <div className="flex justify-end my-6">
        <PrimaryBtn
          ButtonText="Next"
          btnExtraStyle={{ backgroundColor: "#00443f", borderRadius: "1.5rem" }}
          onPress={tabChange}
          id="next-btn"
        />
      </div>
    </>
  );
};

export default InventoryCategoriesTab;
